import script from "./RecommendedArticles.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedArticles.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedArticles.vue?vue&type=style&index=0&id=c1c6510a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1c6510a"]])

export default __exports__